import AppbaseAnalytics from '@appbaseio/analytics';
import fetch from 'cross-fetch';

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var Observable = /*#__PURE__*/function () {
  function Observable() {
    this.observers = [];
  }

  var _proto = Observable.prototype;

  _proto.subscribe = function subscribe(fn, propertiesToSubscribe) {
    this.observers.push({
      callback: fn,
      properties: propertiesToSubscribe
    });
  };

  _proto.unsubscribe = function unsubscribe(fn) {
    if (fn) {
      this.observers = this.observers.filter(function (item) {
        if (item.callback !== fn) {
          return item;
        }

        return null;
      });
    } else {
      this.observers = [];
    }
  };

  _proto.next = function next(o, property, thisObj) {
    var scope = thisObj;

    if (!scope && window) {
      scope = window;
    }

    this.observers.forEach(function (item) {
      // filter by subscribed properties
      if (item.properties === undefined) {
        item.callback.call(scope, o);
      } else if (item.properties instanceof Array && item.properties.length && item.properties.includes(property)) {
        item.callback.call(scope, o);
      } else if (typeof item.properties === 'string' && item.properties && item.properties === property) {
        item.callback.call(scope, o);
      }
    });
  };

  return Observable;
}();

var _excluded = ["label"];
function getErrorMessage(msg) {
  return "SearchBase: " + msg;
}
var errorMessages = {
  invalidIndex: getErrorMessage('Please provide a valid index.'),
  invalidURL: getErrorMessage('Please provide a valid url.'),
  invalidComponentId: getErrorMessage('Please provide component id.'),
  invalidDataField: getErrorMessage('Please provide data field.'),
  dataFieldAsArray: getErrorMessage('Only components with `search` and `suggestion` type supports the multiple data fields. Please define `dataField` as a string.')
};
var queryTypes = {
  Search: 'search',
  Term: 'term',
  Geo: 'geo',
  Range: 'range',
  Suggestion: 'suggestion'
};
var withClickIds = function withClickIds(results) {
  if (results === void 0) {
    results = [];
  }

  return results.map(function (result, index) {
    return _extends({}, result, {
      _click_id: index + 1
    });
  });
};
var highlightResults = function highlightResults(result) {
  var data = _extends({}, result);

  if (data.highlight) {
    Object.keys(data.highlight).forEach(function (highlightItem) {
      var _extends2;

      var highlightValue = data.highlight[highlightItem][0];
      data._source = _extends({}, data._source, (_extends2 = {}, _extends2[highlightItem] = highlightValue, _extends2));
    });
  }

  return data;
};
var parseHits = function parseHits(hits) {
  var results = [];

  if (hits) {
    results = [].concat(hits).map(function (item) {
      var data = highlightResults(item);
      var result = Object.keys(data).filter(function (key) {
        return key !== '_source';
      }).reduce(function (obj, key) {
        // eslint-disable-next-line
        obj[key] = data[key];
        return obj;
      }, _extends({}, data._source));
      return result;
    });
  }

  return results;
};
var getNormalizedField = function getNormalizedField(field) {
  if (field) {
    // if data field is string
    if (!Array.isArray(field)) {
      return [field];
    }

    if (field.length) {
      var fields = [];
      field.forEach(function (dataField) {
        if (typeof dataField === 'string') {
          fields.push(dataField);
        } else if (dataField.field) {
          // if data field is an array of objects
          fields.push(dataField.field);
        }
      });
      return fields;
    }
  }

  return undefined;
};
function isNumber(n) {
  return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
}
var getNormalizedWeights = function getNormalizedWeights(field) {
  if (field && Array.isArray(field) && field.length) {
    var weights = [];
    field.forEach(function (dataField) {
      if (isNumber(dataField.weight)) {
        // if data field is an array of objects
        weights.push(dataField.weight);
      } else {
        // Add default weight as 1 to maintain order
        weights.push(1);
      }
    });
    return weights;
  }

  return undefined;
};
function flatReactProp(reactProp, componentID) {
  var flattenReact = [];

  var flatReact = function flatReact(react) {
    if (react && Object.keys(react)) {
      Object.keys(react).forEach(function (r) {
        if (react[r]) {
          if (typeof react[r] === 'string') {
            flattenReact = [].concat(flattenReact, [react[r]]);
          } else if (Array.isArray(react[r])) {
            flattenReact = [].concat(flattenReact, react[r]);
          } else if (typeof react[r] === 'object') {
            flatReact(react[r]);
          }
        }
      });
    }
  };

  flatReact(reactProp); // Remove cyclic dependencies i.e dependencies on it's own

  flattenReact = flattenReact.filter(function (react) {
    return react !== componentID;
  });
  return flattenReact;
} // flattens a nested array

var flatten = function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
  }, []);
}; // helper function to extract suggestions

var extractSuggestion = function extractSuggestion(val) {
  if (typeof val === 'object') {
    if (Array.isArray(val)) {
      return flatten(val);
    }

    return null;
  }

  return val;
};
function parseCompAggToHits(aggFieldName, buckets) {
  if (buckets === void 0) {
    buckets = [];
  }

  return buckets.map(function (bucket) {
    // eslint-disable-next-line camelcase
    var doc_count = bucket.doc_count,
        key = bucket.key,
        data = bucket[aggFieldName];
    return _extends({
      _doc_count: doc_count,
      // To handle the aggregation results for term and composite aggs
      _key: key[aggFieldName] !== undefined ? key[aggFieldName] : key
    }, data);
  });
}
function isEqual(x, y) {
  if (x === y) return true;
  if (!(x instanceof Object) || !(y instanceof Object)) return false;
  if (x.constructor !== y.constructor) return false;
  /* eslint-disable */

  for (var p in x) {
    if (!x.hasOwnProperty(p)) continue;
    if (!y.hasOwnProperty(p)) return false;
    if (x[p] === y[p]) continue;
    if (typeof x[p] !== 'object') return false;
    if (!isEqual(x[p], y[p])) return false;
  }

  for (var _p in y) {
    if (y.hasOwnProperty(_p) && !x.hasOwnProperty(_p)) return false;
  }
  /* eslint-enable */


  return true;
}
var searchBaseMappings = {
  id: 'id',
  type: 'type',
  react: 'react',
  queryFormat: 'queryFormat',
  dataField: 'dataField',
  categoryField: 'categoryField',
  categoryValue: 'categoryValue',
  nestedField: 'nestedField',
  from: 'from',
  size: 'size',
  sortBy: 'sortBy',
  value: 'value',
  aggregationField: 'aggregationField',
  aggregationSize: 'aggregationSize',
  after: 'after',
  includeNullValues: 'includeNullValues',
  includeFields: 'includeFields',
  excludeFields: 'excludeFields',
  fuzziness: 'fuzziness',
  searchOperators: 'searchOperators',
  highlight: 'highlight',
  highlightField: 'highlightField',
  customHighlight: 'customHighlight',
  interval: 'interval',
  aggregations: 'aggregations',
  missingLabel: 'missingLabel',
  showMissing: 'showMissing',
  enableSynonyms: 'enableSynonyms',
  selectAllLabel: 'selectAllLabel',
  pagination: 'pagination',
  queryString: 'queryString',
  enablePopularSuggestions: 'enablePopularSuggestions',
  showDistinctSuggestions: 'showDistinctSuggestions',
  error: 'error',
  defaultQuery: 'defaultQuery',
  customQuery: 'customQuery',
  requestStatus: 'requestStatus',
  results: 'results',
  aggregationData: 'aggregationData',
  micStatus: 'micStatus',
  micInstance: 'micInstance',
  micActive: 'micActive',
  micInactive: 'micInactive',
  micDenied: 'micDenied',
  query: 'query',
  requestPending: 'loading',
  appbaseSettings: 'appbaseConfig',
  suggestions: 'suggestions',
  queryId: 'queryId',
  recentSearches: 'recentSearches',
  distinctField: 'distinctField',
  distinctFieldConfig: 'distinctFieldConfig',
  // ---------------- Methods -----------------------
  onMicClick: 'handleMicClick',
  triggerDefaultQuery: 'triggerDefaultQuery',
  triggerCustomQuery: 'triggerCustomQuery',
  recordClick: 'recordClick',
  recordConversions: 'recordConversions',
  subscribeToStateChanges: 'subscribeToStateChanges',
  unsubscribeToStateChanges: 'unsubscribeToStateChanges',
  // ---------------- Setter Methods ----------------
  setDataField: 'setDataField',
  setValue: 'setValue',
  setCategoryValue: 'setCategoryValue',
  setSize: 'setSize',
  setFrom: 'setFrom',
  setFuzziness: 'setFuzziness',
  setIncludeFields: 'setIncludeFields',
  setExcludeFields: 'setExcludeFields',
  setSortBy: 'setSortBy',
  setReact: 'setReact',
  setDefaultQuery: 'setDefaultQuery',
  setCustomQuery: 'setCustomQuery',
  setAfter: 'setAfter'
};
function btoa(input) {
  if (input === void 0) {
    input = '';
  }

  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var str = input;
  var output = ''; // eslint-disable-next-line

  for (var block = 0, charCode, i = 0, map = chars; str.charAt(i | 0) || (map = '=', i % 1); // eslint-disable-line no-bitwise
  output += map.charAt(63 & block >> 8 - i % 1 * 8) // eslint-disable-line no-bitwise
  ) {
    charCode = str.charCodeAt(i += 3 / 4);

    if (charCode > 0xff) {
      throw new Error('"btoa" failed: The string to be encoded contains characters outside of the Latin1 range.');
    }

    block = block << 8 | charCode; // eslint-disable-line no-bitwise
  }

  return output;
}
var componentsAlias = {
  SEARCHBASE: 'SearchBase',
  SEARCHCOMPONENT: 'SearchComponent'
};
var backendAlias = {
  MONGODB: 'mongodb',
  // mongodb
  ELASTICSEARCH: 'elasticsearch' // elasticsearch

};
var dataTypes = {
  ARRAY: 'array',
  FUNCTION: 'function',
  OBJECT: 'object',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  STRING: 'string'
};

var checkDataType = function checkDataType(temp) {
  if (typeof temp === dataTypes.OBJECT) {
    if (Array.isArray(temp)) {
      return dataTypes.ARRAY;
    }

    return dataTypes.OBJECT;
  }

  return typeof temp;
};

function validateSchema(passedProperties, schema, backendName, componentName, componentNameForErrorDisplay, isHeadless) {
  if (passedProperties === void 0) {
    passedProperties = {};
  }

  if (schema === void 0) {
    schema = {};
  }

  if (backendName === void 0) {
    backendName = '';
  }

  if (componentName === void 0) {
    componentName = '';
  }

  if (componentNameForErrorDisplay === void 0) {
    componentNameForErrorDisplay = '';
  }

  if (isHeadless === void 0) {
    isHeadless = false;
  }

  var passedPropertiesKeys = Object.keys(passedProperties).filter(function (propertyKey) {
    return !!passedProperties[propertyKey];
  });
  var schemaPropertiesKeys = Object.keys(schema);
  var requiredProperties = [];
  var acceptedProperties = []; // fetch required properties

  schemaPropertiesKeys.forEach(function (propName) {
    var currentProperty = schema[propName];

    if (Object.keys(currentProperty.components).includes(componentName)) {
      acceptedProperties.push(propName);

      if (currentProperty.components[componentName].required) {
        requiredProperties.push(propName);
      }
    }
  }); // check for required properties

  requiredProperties.forEach(function (requiredProperty) {
    if (!passedPropertiesKeys.includes(requiredProperty)) {
      throw new Error(requiredProperty + " is required for " + componentNameForErrorDisplay + " " + (isHeadless ? 'class' : 'component') + " when used with the " + backendName + " Search backend.");
    }
  }); // check for accepted properties

  passedPropertiesKeys.forEach(function (passedPropertyKey) {
    if (!acceptedProperties.includes(passedPropertyKey)) {
      throw new Error(componentNameForErrorDisplay + " " + (isHeadless ? 'class' : 'component') + " doesn't accept a property " + passedPropertyKey + ", backend used is " + backendName + ".");
    }

    var acceptedTypes = Array.isArray(schema[passedPropertyKey].type) ? schema[passedPropertyKey].type : [].concat(schema[passedPropertyKey].type);
    var receivedPropertyType = checkDataType(passedProperties[passedPropertyKey]);

    if (!acceptedTypes.includes(receivedPropertyType)) {
      throw new Error(componentNameForErrorDisplay + " " + (isHeadless ? 'class' : 'component') + " accepts a property " + passedPropertyKey + " with type(s) [" + acceptedTypes.join(', ') + "], but type was set as " + receivedPropertyType + ".");
    }
  });
}
/*
The below code will be removed once mongodb backend starts supporting type suggestion query
As of now, we are processing the suggestions from type:search query, just a workaround
*/

function escapeRegExp(string) {
  if (string === void 0) {
    string = '';
  }

  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

var getPredictiveSuggestions = function getPredictiveSuggestions(_ref) {
  var suggestions = _ref.suggestions,
      currentValue = _ref.currentValue,
      wordsToShowAfterHighlight = _ref.wordsToShowAfterHighlight;
  var suggestionMap = {};

  if (currentValue) {
    var currentValueTrimmed = currentValue.trim();
    var parsedSuggestion = suggestions.reduce(function (agg, _ref2) {
      var label = _ref2.label,
          rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

      // to handle special strings with pattern '<mark>xyz</mark> <a href="test'
      var parsedContent = new DOMParser().parseFromString(label, 'text/html').documentElement.textContent; // to match the partial start of word.
      // example if searchTerm is `select` and string contains `selected`

      var regexString = "^(" + escapeRegExp(currentValueTrimmed) + ")\\w+";
      var regex = new RegExp(regexString, 'i');
      var regexExecution = regex.exec(parsedContent); // if execution value is null it means either there is no match or there are chances
      // that exact word is present

      if (!regexExecution) {
        // regex to match exact word
        regexString = "^(" + escapeRegExp(currentValueTrimmed) + ")";
        regex = new RegExp(regexString, 'i');
        regexExecution = regex.exec(parsedContent);
      }

      if (regexExecution) {
        var matchedString = parsedContent.slice(regexExecution.index, parsedContent.length);
        var highlightedWord = matchedString.slice(currentValueTrimmed.length).split(' ').slice(0, wordsToShowAfterHighlight + 1).join(' ');
        var suggestionPhrase = currentValueTrimmed + "<mark class=\"highlight\">" + highlightedWord + "</mark>";
        var suggestionValue = "" + currentValueTrimmed + highlightedWord; // to show unique results only

        if (!suggestionMap[suggestionPhrase]) {
          suggestionMap[suggestionPhrase] = 1;
          return [].concat(agg, [_extends({}, rest, {
            label: suggestionPhrase,
            value: suggestionValue,
            isPredictiveSuggestion: true
          })]);
        }

        return agg;
      }

      return agg;
    }, []);
    return parsedSuggestion;
  }

  return [];
};
/**
 *
 * @param {array} fields DataFields passed on Search Components
 * @param {array} suggestions Raw Suggestions received from ES
 * @param {string} currentValue Search Term
 * @param {boolean} showDistinctSuggestions When set to true will only return 1 suggestion per document
 * @param {boolean} enablePredictiveSuggestions When set to true will return the predictive suggestions list instead of the deafult list
 */

var getSuggestions = function getSuggestions(fields, suggestions, value, showDistinctSuggestions, enablePredictiveSuggestions) {
  if (fields === void 0) {
    fields = [];
  }

  if (value === void 0) {
    value = '';
  }

  if (showDistinctSuggestions === void 0) {
    showDistinctSuggestions = true;
  }

  if (enablePredictiveSuggestions === void 0) {
    enablePredictiveSuggestions = false;
  }

  var suggestionsList = [];
  var labelsList = [];
  var skipWordMatch = false; //  Use to skip the word match logic, important for synonym

  var currentValue = value || '';

  var populateSuggestionsList = function populateSuggestionsList(val, parsedSource, source) {
    // check if the suggestion includes the current value
    // and not already included in other suggestions
    var isWordMatch = skipWordMatch || currentValue.trim().split(' ').some(function (term) {
      return String(val).toLowerCase().includes(term);
    }); // promoted results should always include in suggestions even there is no match

    if (isWordMatch && !labelsList.includes(val) || source._promoted) {
      var defaultOption = {
        label: val,
        value: val,
        source: source
      };

      var option = _extends({}, defaultOption);

      labelsList = [].concat(labelsList, [val]);
      suggestionsList = [].concat(suggestionsList, [option]);

      if (showDistinctSuggestions) {
        return true;
      }
    }

    return false;
  };

  var parseField = function parseField(parsedSource, field, source) {
    if (field === void 0) {
      field = '';
    }

    if (source === void 0) {
      source = parsedSource;
    }

    if (typeof parsedSource === 'object') {
      var fieldNodes = field.split('.');
      var label = parsedSource[fieldNodes[0]];

      if (label) {
        if (fieldNodes.length > 1) {
          // nested fields of the 'foo.bar.zoo' variety
          var children = field.substring(fieldNodes[0].length + 1);

          if (Array.isArray(label)) {
            label.forEach(function (arrayItem) {
              parseField(arrayItem, children, source);
            });
          } else {
            parseField(label, children, source);
          }
        } else {
          var val = extractSuggestion(label);

          if (val) {
            if (Array.isArray(val)) {
              if (showDistinctSuggestions) {
                return val.some(function (suggestion) {
                  return populateSuggestionsList(suggestion, parsedSource, source);
                });
              }

              val.forEach(function (suggestion) {
                return populateSuggestionsList(suggestion, parsedSource, source);
              });
            }

            return populateSuggestionsList(val, parsedSource, source);
          }
        }
      }
    }

    return false;
  };

  var traverseSuggestions = function traverseSuggestions() {
    if (showDistinctSuggestions) {
      suggestions.forEach(function (item) {
        fields.some(function (field) {
          return parseField(item, field);
        });
      });
    } else {
      suggestions.forEach(function (item) {
        fields.forEach(function (field) {
          parseField(item, field);
        });
      });
    }
  };

  traverseSuggestions();

  if (suggestionsList.length < suggestions.length && !skipWordMatch) {
    /*
    When we have synonym we set skipWordMatch to false as it may discard
    the suggestion if word doesnt match term.
    For eg: iphone, ios are synonyms and on searching iphone isWordMatch
    in  populateSuggestionList may discard ios source which decreases no.
    of items in suggestionsList
    */
    skipWordMatch = true;
    traverseSuggestions();
  }

  if (enablePredictiveSuggestions) {
    return getPredictiveSuggestions({
      suggestions: suggestionsList,
      currentValue: value,
      wordsToShowAfterHighlight: true
    });
  }

  return suggestionsList;
};
var LIBRARY_ALIAS = {
  REACT_SEARCHBOX: 'react-searchbox',
  VUE_SEARCHBOX: 'vue-searchbox',
  SEARCHBOX: 'searchbox',
  SEARCHBASE: 'searchbase',
  NATIVE: 'native'
};

var _components, _components2, _components3, _components4, _components5, _components6, _components7, _components8, _components9, _components10, _components11, _components12, _components13, _components14, _components15, _components16, _components17, _components18, _components19, _components20, _components21, _components22, _components23, _components24, _components25, _components26, _components27, _components28, _components29, _components30;
var SEARCHBASE = componentsAlias.SEARCHBASE,
    SEARCHCOMPONENT = componentsAlias.SEARCHCOMPONENT;
var mongodb = {
  url: {
    components: (_components = {}, _components[SEARCHBASE] = {
      required: true
    }, _components[SEARCHCOMPONENT] = {
      required: true
    }, _components),
    type: dataTypes.STRING
  },
  index: {
    components: (_components2 = {}, _components2[SEARCHBASE] = {
      required: false
    }, _components2[SEARCHCOMPONENT] = {
      required: false
    }, _components2),
    type: dataTypes.STRING
  },
  credentials: {
    components: (_components3 = {}, _components3[SEARCHBASE] = {
      required: false
    }, _components3[SEARCHCOMPONENT] = {
      required: false
    }, _components3),
    type: dataTypes.STRING
  },
  headers: {
    components: (_components4 = {}, _components4[SEARCHBASE] = {
      required: false
    }, _components4[SEARCHCOMPONENT] = {
      required: false
    }, _components4),
    type: dataTypes.OBJECT
  },
  transformRequest: {
    components: (_components5 = {}, _components5[SEARCHBASE] = {
      required: false
    }, _components5[SEARCHCOMPONENT] = {
      required: false
    }, _components5),
    type: dataTypes.FUNCTION
  },
  transformResponse: {
    components: (_components6 = {}, _components6[SEARCHBASE] = {
      required: false
    }, _components6[SEARCHCOMPONENT] = {
      required: false
    }, _components6),
    type: dataTypes.FUNCTION
  },
  mongodb: {
    components: (_components7 = {}, _components7[SEARCHBASE] = {
      required: true
    }, _components7[SEARCHCOMPONENT] = {
      required: false
    }, _components7),
    type: dataTypes.OBJECT
  },
  id: {
    components: (_components8 = {}, _components8[SEARCHCOMPONENT] = {
      required: false
    }, _components8),
    type: dataTypes.STRING
  },
  dataField: {
    components: (_components9 = {}, _components9[SEARCHCOMPONENT] = {
      required: false
    }, _components9),
    type: [dataTypes.ARRAY, dataTypes.STRING]
  },
  autocompleteField: {
    components: (_components10 = {}, _components10[SEARCHCOMPONENT] = {
      required: false
    }, _components10),
    type: [dataTypes.ARRAY, dataTypes.STRING]
  },
  react: {
    components: (_components11 = {}, _components11[SEARCHCOMPONENT] = {
      required: false
    }, _components11),
    type: dataTypes.OBJECT
  },
  size: {
    components: (_components12 = {}, _components12[SEARCHCOMPONENT] = {
      required: false
    }, _components12),
    type: dataTypes.NUMBER
  },
  from: {
    components: (_components13 = {}, _components13[SEARCHCOMPONENT] = {
      required: false
    }, _components13),
    type: dataTypes.NUMBER
  },
  includeFields: {
    components: (_components14 = {}, _components14[SEARCHCOMPONENT] = {
      required: false
    }, _components14),
    type: dataTypes.ARRAY
  },
  excludeFields: {
    components: (_components15 = {}, _components15[SEARCHCOMPONENT] = {
      required: false
    }, _components15),
    type: dataTypes.ARRAY
  },
  sortBy: {
    components: (_components16 = {}, _components16[SEARCHCOMPONENT] = {
      required: false
    }, _components16),
    type: dataTypes.STRING
  },
  aggregationSize: {
    components: (_components17 = {}, _components17[SEARCHCOMPONENT] = {
      required: false
    }, _components17),
    type: dataTypes.NUMBER
  },
  aggregations: {
    components: (_components18 = {}, _components18[SEARCHCOMPONENT] = {
      required: false
    }, _components18),
    type: dataTypes.ARRAY
  },
  highlight: {
    components: (_components19 = {}, _components19[SEARCHCOMPONENT] = {
      required: false
    }, _components19),
    type: dataTypes.BOOLEAN
  },
  highlightField: {
    components: (_components20 = {}, _components20[SEARCHCOMPONENT] = {
      required: false
    }, _components20),
    type: dataTypes.STRING
  },
  highlightConfig: {
    components: (_components21 = {}, _components21[SEARCHCOMPONENT] = {
      required: false
    }, _components21),
    type: dataTypes.OBJECT
  },
  fuzziness: {
    components: (_components22 = {}, _components22[SEARCHCOMPONENT] = {
      required: false
    }, _components22),
    type: [dataTypes.STRING, dataTypes.NUMBER]
  },
  enableSynonyms: {
    components: (_components23 = {}, _components23[SEARCHCOMPONENT] = {
      required: false
    }, _components23),
    type: dataTypes.BOOLEAN
  },
  searchOperators: {
    components: (_components24 = {}, _components24[SEARCHCOMPONENT] = {
      required: false
    }, _components24),
    type: dataTypes.BOOLEAN
  },
  queryString: {
    components: (_components25 = {}, _components25[SEARCHCOMPONENT] = {
      required: false
    }, _components25),
    type: dataTypes.STRING
  },
  defaultQuery: {
    components: (_components26 = {}, _components26[SEARCHCOMPONENT] = {
      required: false
    }, _components26),
    type: [dataTypes.FUNCTION, dataTypes.OBJECT]
  },
  customQuery: {
    components: (_components27 = {}, _components27[SEARCHCOMPONENT] = {
      required: false
    }, _components27),
    type: [dataTypes.FUNCTION, dataTypes.OBJECT]
  },
  value: {
    components: (_components28 = {}, _components28[SEARCHCOMPONENT] = {
      required: false
    }, _components28),
    type: [dataTypes.STRING, dataTypes.ARRAY, dataTypes.OBJECT]
  },
  type: {
    components: (_components29 = {}, _components29[SEARCHCOMPONENT] = {
      required: false
    }, _components29),
    type: dataTypes.STRING
  },
  queryFormat: {
    components: (_components30 = {}, _components30[SEARCHCOMPONENT] = {
      required: false
    }, _components30),
    type: dataTypes.STRING
  }
};

var _components$1, _components2$1, _components3$1, _components4$1, _components5$1, _components6$1, _components7$1, _components8$1, _components9$1, _components10$1, _components11$1, _components12$1, _components13$1, _components14$1, _components15$1, _components16$1, _components17$1, _components18$1, _components19$1, _components20$1, _components21$1, _components22$1, _components23$1, _components24$1, _components25$1, _components26$1, _components27$1, _components28$1, _components29$1, _components30$1, _components31, _components32, _components33, _components34, _components35, _components36, _components37, _components38, _components39, _components40, _components41, _components42, _components43, _components44, _components45, _components46, _components47, _components48, _components49, _components50;
var SEARCHBASE$1 = componentsAlias.SEARCHBASE,
    SEARCHCOMPONENT$1 = componentsAlias.SEARCHCOMPONENT;
var elasticsearch = {
  url: {
    components: (_components$1 = {}, _components$1[SEARCHBASE$1] = {
      required: true
    }, _components$1[SEARCHCOMPONENT$1] = {
      required: true
    }, _components$1),
    type: dataTypes.STRING
  },
  index: {
    components: (_components2$1 = {}, _components2$1[SEARCHBASE$1] = {
      required: true
    }, _components2$1[SEARCHCOMPONENT$1] = {
      required: true
    }, _components2$1),
    type: dataTypes.STRING
  },
  credentials: {
    components: (_components3$1 = {}, _components3$1[SEARCHBASE$1] = {
      required: true
    }, _components3$1[SEARCHCOMPONENT$1] = {
      required: true
    }, _components3$1),
    type: dataTypes.STRING
  },
  appbaseConfig: {
    components: (_components4$1 = {}, _components4$1[SEARCHBASE$1] = {
      required: false
    }, _components4$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components4$1),
    type: dataTypes.OBJECT
  },
  headers: {
    components: (_components5$1 = {}, _components5$1[SEARCHBASE$1] = {
      required: false
    }, _components5$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components5$1),
    type: dataTypes.OBJECT
  },
  transformRequest: {
    components: (_components6$1 = {}, _components6$1[SEARCHBASE$1] = {
      required: false
    }, _components6$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components6$1),
    type: dataTypes.FUNCTION
  },
  transformResponse: {
    components: (_components7$1 = {}, _components7$1[SEARCHBASE$1] = {
      required: false
    }, _components7$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components7$1),
    type: dataTypes.FUNCTION
  },
  id: {
    components: (_components8$1 = {}, _components8$1[SEARCHCOMPONENT$1] = {
      required: true
    }, _components8$1),
    type: dataTypes.STRING,
    required: true
  },
  dataField: {
    components: (_components9$1 = {}, _components9$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components9$1),
    type: [dataTypes.ARRAY, dataTypes.STRING]
  },
  autocompleteField: {
    components: (_components10$1 = {}, _components10$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components10$1),
    type: [dataTypes.ARRAY, dataTypes.STRING]
  },
  queryFormat: {
    components: (_components11$1 = {}, _components11$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components11$1),
    type: dataTypes.STRING
  },
  react: {
    components: (_components12$1 = {}, _components12$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components12$1),
    type: dataTypes.OBJECT
  },
  size: {
    components: (_components13$1 = {}, _components13$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components13$1),
    type: dataTypes.NUMBER
  },
  from: {
    components: (_components14$1 = {}, _components14$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components14$1),
    type: dataTypes.NUMBER
  },
  includeFields: {
    components: (_components15$1 = {}, _components15$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components15$1),
    type: dataTypes.ARRAY
  },
  excludeFields: {
    components: (_components16$1 = {}, _components16$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components16$1),
    type: dataTypes.ARRAY
  },
  sortBy: {
    components: (_components17$1 = {}, _components17$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components17$1),
    type: dataTypes.STRING
  },
  aggregationField: {
    components: (_components18$1 = {}, _components18$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components18$1),
    type: dataTypes.STRING
  },
  aggregationSize: {
    components: (_components19$1 = {}, _components19$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components19$1),
    type: dataTypes.NUMBER
  },
  highlight: {
    components: (_components20$1 = {}, _components20$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components20$1),
    type: dataTypes.BOOLEAN
  },
  highlightField: {
    components: (_components21$1 = {}, _components21$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components21$1),
    type: dataTypes.STRING
  },
  customHighlight: {
    components: (_components22$1 = {}, _components22$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components22$1),
    type: dataTypes.OBJECT
  },
  categoryField: {
    components: (_components23$1 = {}, _components23$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components23$1),
    type: dataTypes.STRING
  },
  categoryValue: {
    components: (_components24$1 = {}, _components24$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components24$1),
    type: dataTypes.STRING
  },
  nestedField: {
    components: (_components25$1 = {}, _components25$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components25$1),
    type: dataTypes.STRING
  },
  fuzziness: {
    components: (_components26$1 = {}, _components26$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components26$1),
    type: [dataTypes.STRING, dataTypes.NUMBER]
  },
  enableSynonyms: {
    components: (_components27$1 = {}, _components27$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components27$1),
    type: dataTypes.BOOLEAN
  },
  searchOperators: {
    components: (_components28$1 = {}, _components28$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components28$1),
    type: dataTypes.BOOLEAN
  },
  queryString: {
    components: (_components29$1 = {}, _components29$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components29$1),
    type: dataTypes.STRING
  },
  distinctField: {
    components: (_components30$1 = {}, _components30$1[SEARCHCOMPONENT$1] = {
      required: false
    }, _components30$1),
    type: dataTypes.STRING
  },
  distinctFieldConfig: {
    components: (_components31 = {}, _components31[SEARCHCOMPONENT$1] = {
      required: false
    }, _components31),
    type: dataTypes.OBJECT
  },
  enableRecentSuggestions: {
    components: (_components32 = {}, _components32[SEARCHCOMPONENT$1] = {
      required: false
    }, _components32),
    type: dataTypes.BOOLEAN
  },
  enableRecentSearches: {
    components: (_components33 = {}, _components33[SEARCHCOMPONENT$1] = {
      required: false
    }, _components33),
    type: dataTypes.BOOLEAN
  },
  enablePopularSuggestions: {
    components: (_components34 = {}, _components34[SEARCHCOMPONENT$1] = {
      required: false
    }, _components34),
    type: dataTypes.BOOLEAN
  },
  recentSuggestionsConfig: {
    components: (_components35 = {}, _components35[SEARCHCOMPONENT$1] = {
      required: false
    }, _components35),
    type: dataTypes.OBJECT
  },
  popularSuggestionsConfig: {
    components: (_components36 = {}, _components36[SEARCHCOMPONENT$1] = {
      required: false
    }, _components36),
    type: dataTypes.OBJECT
  },
  enablePredictiveSuggestions: {
    components: (_components37 = {}, _components37[SEARCHCOMPONENT$1] = {
      required: false
    }, _components37),
    type: dataTypes.BOOLEAN
  },
  maxPredictedWords: {
    components: (_components38 = {}, _components38[SEARCHCOMPONENT$1] = {
      required: false
    }, _components38),
    type: dataTypes.NUMBER
  },
  urlField: {
    components: (_components39 = {}, _components39[SEARCHCOMPONENT$1] = {
      required: false
    }, _components39),
    type: dataTypes.STRING
  },
  pagination: {
    components: (_components40 = {}, _components40[SEARCHCOMPONENT$1] = {
      required: false
    }, _components40),
    type: dataTypes.BOOLEAN
  },
  after: {
    components: (_components41 = {}, _components41[SEARCHCOMPONENT$1] = {
      required: false
    }, _components41),
    type: dataTypes.OBJECT
  },
  showMissing: {
    components: (_components42 = {}, _components42[SEARCHCOMPONENT$1] = {
      required: false
    }, _components42),
    type: dataTypes.BOOLEAN
  },
  includeNullValues: {
    components: (_components43 = {}, _components43[SEARCHCOMPONENT$1] = {
      required: false
    }, _components43),
    type: dataTypes.BOOLEAN
  },
  interval: {
    components: (_components44 = {}, _components44[SEARCHCOMPONENT$1] = {
      required: false
    }, _components44),
    type: dataTypes.NUMBER
  },
  aggregations: {
    components: (_components45 = {}, _components45[SEARCHCOMPONENT$1] = {
      required: false
    }, _components45),
    type: dataTypes.ARRAY
  },
  defaultQuery: {
    components: (_components46 = {}, _components46[SEARCHCOMPONENT$1] = {
      required: false
    }, _components46),
    type: [dataTypes.FUNCTION, dataTypes.OBJECT]
  },
  customQuery: {
    components: (_components47 = {}, _components47[SEARCHCOMPONENT$1] = {
      required: false
    }, _components47),
    type: [dataTypes.FUNCTION, dataTypes.OBJECT]
  },
  value: {
    components: (_components48 = {}, _components48[SEARCHCOMPONENT$1] = {
      required: false
    }, _components48),
    type: [dataTypes.STRING, dataTypes.ARRAY, dataTypes.OBJECT]
  },
  type: {
    components: (_components49 = {}, _components49[SEARCHCOMPONENT$1] = {
      required: false
    }, _components49),
    type: dataTypes.STRING
  },
  clearOnQueryChange: {
    components: (_components50 = {}, _components50[SEARCHCOMPONENT$1] = {
      required: false
    }, _components50),
    type: dataTypes.BOOLEAN
  }
};

var SCHEMA = {
  mongodb: mongodb,
  elasticsearch: elasticsearch
};

/**
 * Base class is the abstract class for SearchBase and SearchComponent classes.
 */

var Base = /*#__PURE__*/function () {
  // to enable the recording of analytics
  // auth credentials if any
  // mongodb
  // custom headers object
  // es index name
  // es url

  /* ---- callbacks to create the side effects while querying ----- */

  /* ------ Private properties only for the internal use ----------- */
  // analytics instance
  // query search ID
  function Base(_ref) {
    var index = _ref.index,
        url = _ref.url,
        credentials = _ref.credentials,
        headers = _ref.headers,
        mongodb = _ref.mongodb,
        appbaseConfig = _ref.appbaseConfig,
        transformRequest = _ref.transformRequest,
        transformResponse = _ref.transformResponse,
        libAlias = _ref.libAlias;
    var backendName = backendAlias[mongodb ? 'MONGODB' : 'ELASTICSEARCH']; // eslint-disable-next-line

    var schema = SCHEMA[backendName];
    validateSchema({
      index: index,
      url: url,
      credentials: credentials,
      headers: headers,
      mongodb: mongodb,
      appbaseConfig: appbaseConfig,
      transformRequest: transformRequest,
      transformResponse: transformResponse
    }, schema, backendName, componentsAlias.SEARCHBASE, componentsAlias.SEARCHBASE, !libAlias || libAlias === LIBRARY_ALIAS.SEARCHBASE);
    this.index = index;
    this.url = url;
    this.credentials = credentials || '';
    this.mongodb = mongodb;

    if (appbaseConfig) {
      this.appbaseConfig = appbaseConfig;
    }

    if (transformRequest) {
      this.transformRequest = transformRequest;
    }

    if (transformResponse) {
      this.transformResponse = transformResponse;
    }

    var _ref2 = appbaseConfig || {},
        enableTelemetry = _ref2.enableTelemetry; // Initialize headers


    this.headers = _extends({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, !this.mongodb ? _extends({
      'x-search-client': 'Searchbase Headless'
    }, enableTelemetry === false ? {
      'X-Enable-Telemetry': false
    } : {}) : {});

    if (this.credentials) {
      this.headers = _extends({}, this.headers, {
        Authorization: "Basic " + btoa(this.credentials)
      });
    }

    if (headers) {
      this.setHeaders(headers);
    }

    if (!this.mongodb) {
      // Create analytics index
      this._analyticsInstance = AppbaseAnalytics.init({
        index: index,
        url: url,
        credentials: credentials
      });
    }
  } // To to set the custom headers


  var _proto = Base.prototype;

  _proto.setHeaders = function setHeaders(headers) {
    this.headers = _extends({}, this.headers, headers);
  } // To set the query ID
  ;

  _proto.setQueryID = function setQueryID(queryID) {
    this._queryId = queryID;
  };

  return Base;
}();

var Results = /*#__PURE__*/function () {
  // An array of results obtained from the applied query.
  // Raw response returned by ES query
  // Results parser
  function Results(data) {
    var _this = this;

    this.setRaw = function (rawResponse) {
      // set response
      _this.raw = rawResponse;

      if (rawResponse.hits && rawResponse.hits.hits) {
        _this.setData(rawResponse.hits.hits);
      }
    };

    this.data = data || [];
  } // Total number of results found


  var _proto = Results.prototype;

  // Method to set data explicitly
  _proto.setData = function setData(data) {
    // parse hits
    var filteredResults = parseHits(data); // filter results & remove duplicates if any

    if (this.promotedData.length) {
      var ids = this.promotedData.map(function (item) {
        return item._id;
      }).filter(Boolean);

      if (ids) {
        filteredResults = filteredResults.filter(function (item) {
          return !ids.includes(item._id);
        });
      }

      filteredResults = [].concat(this.promotedData.map(function (dataItem) {
        return _extends({}, dataItem, {
          _promoted: true
        });
      }), filteredResults);
    } // set data


    if (this.parseResults) {
      this.data = this.parseResults(filteredResults, data);
    } else {
      this.data = filteredResults;
    } // Add click ids in data


    this.data = withClickIds(this.data);
  };

  _createClass(Results, [{
    key: "numberOfResults",
    get: function get() {
      // calculate from raw response
      if (this.raw && this.raw.hits) {
        return typeof this.raw.hits.total === 'object' ? this.raw.hits.total.value : this.raw.hits.total;
      }

      return 0;
    } // Total time taken by request (in ms)

  }, {
    key: "time",
    get: function get() {
      // calculate from raw response
      if (this.raw) {
        return this.raw.took;
      }

      return 0;
    } // no of hidden results found

  }, {
    key: "hidden",
    get: function get() {
      if (this.raw && this.raw.hits) {
        return this.raw.hits.hidden || 0;
      }

      return 0;
    } // An array of promoted results obtained from the applied query.

  }, {
    key: "promotedData",
    get: function get() {
      if (this.raw && this.raw.promoted) {
        return this.raw.promoted || [];
      }

      return [];
    } // no of promoted results found

  }, {
    key: "promoted",
    get: function get() {
      return this.promotedData.length || 0;
    } // An object of raw response as-is from elasticsearch query

  }, {
    key: "rawData",
    get: function get() {
      return this.raw || {};
    } // object of custom data applied through queryRules
    // only works when `enableAppbase=true`

  }, {
    key: "customData",
    get: function get() {
      if (this.raw && this.raw.customData) {
        return this.raw.customData || {};
      }

      return {};
    }
  }]);

  return Results;
}();

var Aggregations = /*#__PURE__*/function () {
  // An array of composite aggregations obtained from the applied aggs in options.
  // useful when loading data of greater size
  // Raw aggregations returned by ES query
  function Aggregations(data) {
    this.data = data || [];
  } // An object of raw response as-is from elasticsearch query


  var _proto = Aggregations.prototype;

  _proto.setRaw = function setRaw(rawResponse) {
    // set response
    this.raw = rawResponse;
    if (rawResponse && rawResponse.after_key) this.setAfterKey(rawResponse.after_key);
  };

  _proto.setAfterKey = function setAfterKey(key) {
    this.afterKey = key;
  } // Method to set data explicitly
  ;

  _proto.setData = function setData(aggField, data, append) {
    if (append === void 0) {
      append = false;
    }

    // parse aggregation buckets
    var parsedData = parseCompAggToHits(aggField, data); // Merge data

    if (append) {
      this.data = [].concat(this.data, parsedData);
    } else {
      this.data = parsedData;
    }
  };

  _createClass(Aggregations, [{
    key: "rawData",
    get: function get() {
      return this.raw || {};
    }
  }]);

  return Aggregations;
}();

var _excluded$1 = ["index", "url", "credentials", "mongodb", "appbaseConfig", "headers", "transformRequest", "transformResponse", "beforeValueChange", "onValueChange", "onResults", "onAggregationData", "onError", "onRequestStatusChange", "onQueryChange", "onMicStatusChange", "enablePopularSuggestions", "maxPopularSuggestions", "results", "showDistinctSuggestions", "enablePredictiveSuggestions", "preserveResults", "clearOnQueryChange", "autocompleteField", "highlightConfig", "componentName", "libAlias"];
var defaultOptions = {
  triggerDefaultQuery: true,
  triggerCustomQuery: false,
  stateChanges: true
};
var defaultOption = {
  stateChanges: true
};
var MIC_STATUS = {
  inactive: 'INACTIVE',
  active: 'ACTIVE',
  denied: 'DENIED'
};
var REQUEST_STATUS = {
  inactive: 'INACTIVE',
  pending: 'PENDING',
  error: 'ERROR'
};
/**
 * SearchComponent class is responsible for the following things:
 * - It provides the methods to trigger the query
 * - It maintains the request state for e.g loading, error etc.
 * - It handles the `custom` and `default` queries
 * - Basically the SearchComponent class provides all the utilities to build any ReactiveSearch component
 */

var SearchComponent = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SearchComponent, _Base);

  // RS API properties
  // other properties
  // To enable the popular suggestions
  // size of the popular suggestions
  // To show the distinct suggestions
  // To show the predictive suggestions
  // preserve the data for infinite loading
  // to clear the dependent facets values on query change
  // query error
  // state changes subject
  // request status
  // results
  // aggregations

  /* ------ Private properties only for the internal use ----------- */
  // Counterpart of the query
  // TODO: Check on the below properties
  // mic status
  // mic instance
  // query search ID
  // tracks the last request time for default query
  // tracks the last request time for custom query

  /* ---- callbacks to create the side effects while querying ----- */

  /* ------------- change events -------------------------------- */
  // called when value changes
  // called when results change
  // called when composite aggregationData change
  // called when there is an error while fetching results
  // called when request status changes
  // called when query changes
  // called when mic status changes
  function SearchComponent(_ref) {
    var _this;

    var index = _ref.index,
        url = _ref.url,
        credentials = _ref.credentials,
        mongodb = _ref.mongodb,
        appbaseConfig = _ref.appbaseConfig,
        headers = _ref.headers,
        transformRequest = _ref.transformRequest,
        transformResponse = _ref.transformResponse,
        beforeValueChange = _ref.beforeValueChange,
        onValueChange = _ref.onValueChange,
        onResults = _ref.onResults,
        onAggregationData = _ref.onAggregationData,
        onError = _ref.onError,
        onRequestStatusChange = _ref.onRequestStatusChange,
        onQueryChange = _ref.onQueryChange,
        onMicStatusChange = _ref.onMicStatusChange,
        enablePopularSuggestions = _ref.enablePopularSuggestions,
        maxPopularSuggestions = _ref.maxPopularSuggestions,
        _results = _ref.results,
        showDistinctSuggestions = _ref.showDistinctSuggestions,
        enablePredictiveSuggestions = _ref.enablePredictiveSuggestions,
        preserveResults = _ref.preserveResults,
        clearOnQueryChange = _ref.clearOnQueryChange,
        autocompleteField = _ref.autocompleteField,
        highlightConfig = _ref.highlightConfig,
        componentName = _ref.componentName,
        libAlias = _ref.libAlias,
        rsAPIConfig = _objectWithoutPropertiesLoose(_ref, _excluded$1);

    _this = _Base.call(this, {
      index: index,
      url: url,
      credentials: credentials,
      mongodb: mongodb,
      headers: headers,
      appbaseConfig: appbaseConfig,
      transformRequest: transformRequest,
      transformResponse: transformResponse,
      libAlias: libAlias
    }) || this;

    _this.onMicClick = function (micOptions, options) {
      if (micOptions === void 0) {
        micOptions = {};
      }

      if (options === void 0) {
        options = {
          triggerDefaultQuery: false,
          triggerCustomQuery: false,
          stateChanges: true
        };
      }

      var prevStatus = _this._micStatus;

      if (typeof window !== 'undefined') {
        window.SpeechRecognition = window.webkitSpeechRecognition || window.SpeechRecognition || null;
      }

      if (window && window.SpeechRecognition && prevStatus !== MIC_STATUS.denied) {
        if (prevStatus === MIC_STATUS.active) {
          _this._setMicStatus(MIC_STATUS.inactive, options);
        }

        var _window = window,
            SpeechRecognition = _window.SpeechRecognition;

        if (_this._micInstance) {
          _this._stopMic();

          return;
        }

        _this._micInstance = new SpeechRecognition();
        _this._micInstance.continuous = true;
        _this._micInstance.interimResults = true;
        Object.assign(_this._micInstance, micOptions);

        _this._micInstance.start();

        _this._micInstance.onstart = function () {
          _this._setMicStatus(MIC_STATUS.active, options);
        };

        _this._micInstance.onresult = function (_ref2) {
          var results = _ref2.results;

          if (results && results[0] && results[0].isFinal) {
            _this._stopMic();
          }

          _this._handleVoiceResults({
            results: results
          }, options);
        };

        _this._micInstance.onerror = function (e) {
          if (e.error === 'no-speech' || e.error === 'audio-capture') {
            _this._setMicStatus(MIC_STATUS.inactive, options);
          } else if (e.error === 'not-allowed') {
            _this._setMicStatus(MIC_STATUS.denied, options);
          }

          console.error(e);
        };
      }
    };

    _this.setDataField = function (dataField, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.dataField;
      _this.dataField = dataField;

      _this._applyOptions(options, 'dataField', prev, dataField);
    };

    _this.setParent = function (parent) {
      _this._parent = parent;
    };

    _this.setValue = function (value, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var performUpdate = function performUpdate() {
        var prev = _this.value;
        _this.value = value;

        _this._applyOptions(options, 'value', prev, _this.value);
      };

      if (_this.beforeValueChange) {
        _this.beforeValueChange(value).then(performUpdate)["catch"](function (e) {
          console.warn('beforeValueChange rejected the promise with ', e);
        });
      } else {
        performUpdate();
      }
    };

    _this.setCategoryValue = function (value, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.categoryValue;
      _this.categoryValue = value;

      _this._applyOptions(options, 'categoryValue', prev, _this.value);
    };

    _this.setSize = function (size, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.size;
      _this.size = size;

      _this._applyOptions(options, 'size', prev, _this.size);
    };

    _this.setFrom = function (from, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.from;
      _this.from = from;

      _this._applyOptions(options, 'from', prev, _this.from);
    };

    _this.setFuzziness = function (fuzziness, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.fuzziness;
      _this.fuzziness = fuzziness;

      _this._applyOptions(options, 'fuzziness', prev, _this.fuzziness);
    };

    _this.setIncludeFields = function (includeFields, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.includeFields;
      _this.includeFields = includeFields;

      _this._applyOptions(options, 'includeFields', prev, includeFields);
    };

    _this.setExcludeFields = function (excludeFields, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.excludeFields;
      _this.excludeFields = excludeFields;

      _this._applyOptions(options, 'excludeFields', prev, excludeFields);
    };

    _this.setSortBy = function (sortBy, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.sortBy;
      _this.sortBy = sortBy;

      _this._applyOptions(options, 'sortBy', prev, sortBy);
    };

    _this.setReact = function (react, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.react;
      _this.react = react;

      _this._applyOptions(options, 'react', prev, react);
    };

    _this.setDefaultQuery = function (defaultQuery, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.defaultQuery;
      _this.defaultQuery = defaultQuery;

      _this._applyOptions(options, 'defaultQuery', prev, defaultQuery);
    };

    _this.setCustomQuery = function (customQuery, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.customQuery;
      _this.customQuery = customQuery;

      _this._applyOptions(options, 'customQuery', prev, customQuery);
    };

    _this.setAfter = function (after, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prev = _this.after;
      _this.after = after;

      _this.aggregationData.setAfterKey(after);

      _this._applyOptions(options, 'after', prev, after);
    };

    _this.triggerDefaultQuery = function (options) {
      if (options === void 0) {
        options = defaultOption;
      }

      // To prevent duplicate queries
      if (isEqual(_this._query ? JSON.parse(JSON.stringify(_this._query)) : undefined, JSON.parse(JSON.stringify(_this.componentQuery)))) {
        return Promise.resolve(true);
      }

      var handleError = function handleError(err) {
        _this._setError(err, {
          stateChanges: options.stateChanges
        });

        console.error(err);
        return Promise.reject(err);
      };

      try {
        _this._updateQuery();

        _this._setRequestStatus(REQUEST_STATUS.pending); // Set the latest request time


        _this._lastRequestTimeDefaultQuery = new Date().getTime();
        return _this._fetchRequest({
          query: Array.isArray(_this.query) ? _this.query : [_this.query],
          settings: _this.appbaseSettings
        }).then(function (results) {
          if (_this._lastRequestTimeDefaultQuery <= results._timestamp) {
            var _prev = _this.results;
            var rawResults = results && results[_this.id];

            var afterResponse = function afterResponse() {
              if (rawResults.aggregations) {
                _this._handleAggregationResponse(rawResults.aggregations, _extends({
                  defaultOptions: defaultOptions
                }, options));
              }

              _this._setRequestStatus(REQUEST_STATUS.inactive);

              _this._applyOptions({
                stateChanges: options.stateChanges
              }, 'results', _prev, _this.results);
            };

            _this._appendResults(rawResults);

            afterResponse();
            return Promise.resolve(rawResults);
          }

          return Promise.resolve([]);
        })["catch"](handleError);
      } catch (err) {
        return handleError(err);
      }
    };

    _this.triggerCustomQuery = function (options) {
      if (options === void 0) {
        options = defaultOption;
      }

      // Generate query again after resetting changes
      var _this$_generateQuery = _this._generateQuery(),
          requestBody = _this$_generateQuery.requestBody,
          orderOfQueries = _this$_generateQuery.orderOfQueries;

      if (requestBody.length) {
        if (isEqual(_this._query, requestBody)) {
          return Promise.resolve(true);
        }

        var handleError = function handleError(err) {
          _this._setError(err, {
            stateChanges: options.stateChanges
          });

          console.error(err);
          return Promise.reject(err);
        };

        try {
          // set the request loading to true for all the requests
          orderOfQueries.forEach(function (id) {
            var componentInstance = _this._parent.getComponent(id);

            if (componentInstance) {
              // Reset `from` and `after` values
              componentInstance.setFrom(0, {
                stateChanges: true,
                triggerDefaultQuery: false,
                triggerCustomQuery: false
              });
              componentInstance.setAfter(undefined, {
                stateChanges: true,
                triggerDefaultQuery: false,
                triggerCustomQuery: false
              }); // Reset value for dependent components after fist query is made
              // We wait for first query to not clear filters applied by URL params

              if (_this.clearOnQueryChange && _this._query) {
                componentInstance.setValue(undefined, {
                  stateChanges: true,
                  triggerDefaultQuery: false,
                  triggerCustomQuery: false
                });
              }

              componentInstance._setRequestStatus(REQUEST_STATUS.pending); // Update the query


              componentInstance._updateQuery();
            }
          }); // Set the latest request time

          _this._lastRequestTimeCustomQuery = new Date().getTime(); // Re-generate query after changes

          var _this$_generateQuery2 = _this._generateQuery(),
              finalRequest = _this$_generateQuery2.requestBody;

          return _this._fetchRequest({
            query: finalRequest,
            settings: _this.appbaseSettings
          }).then(function (results) {
            if (_this._lastRequestTimeCustomQuery <= results._timestamp) {
              // Update the state for components
              orderOfQueries.forEach(function (id) {
                var componentInstance = _this._parent.getComponent(id);

                if (componentInstance) {
                  componentInstance._setRequestStatus(REQUEST_STATUS.inactive); // Update the results


                  var _prev2 = componentInstance.results; // Collect results from the response for a particular component

                  var rawResults = results && results[id]; // Set results

                  if (rawResults.hits) {
                    componentInstance.results.setRaw(rawResults);

                    componentInstance._applyOptions({
                      stateChanges: options.stateChanges
                    }, 'results', _prev2, componentInstance.results);
                  }

                  if (rawResults.aggregations) {
                    componentInstance._handleAggregationResponse(rawResults.aggregations, _extends({
                      defaultOptions: defaultOptions
                    }, options), false);
                  }
                }
              });
              return Promise.resolve(results);
            }

            return Promise.resolve([]);
          })["catch"](handleError);
        } catch (err) {
          return handleError(err);
        }
      } else {
        return Promise.resolve({});
      }
    };

    _this.recordClick = function (objects, isSuggestionClick) {
      if (isSuggestionClick === void 0) {
        isSuggestionClick = false;
      }

      if (_this._analyticsInstance && _this.queryId) {
        _this._analyticsInstance.click({
          queryID: _this.queryId,
          objects: objects,
          isSuggestionClick: isSuggestionClick
        });
      }
    };

    _this.recordConversions = function (objects) {
      if (_this._analyticsInstance && _this.queryId) {
        _this._analyticsInstance.conversion({
          queryID: _this.queryId,
          objects: objects
        });
      }
    };

    _this.subscribeToStateChanges = function (fn, propertiesToSubscribe) {
      _this.stateChanges.subscribe(fn, propertiesToSubscribe);
    };

    _this.unsubscribeToStateChanges = function (fn) {
      _this.stateChanges.unsubscribe(fn);
    };

    _this.clearResults = function (options) {
      if (options === void 0) {
        options = defaultOption;
      }

      var prev = _this.results;

      _this.results.setRaw({
        hits: {
          hits: []
        }
      });

      _this._applyOptions({
        stateChanges: options.stateChanges
      }, 'results', prev, _this.results);
    };

    _this._handleVoiceResults = function (_ref3, options) {
      var results = _ref3.results;

      if (options === void 0) {
        options = defaultOptions;
      }

      if (results && results[0] && results[0].isFinal && results[0][0] && results[0][0].transcript && results[0][0].transcript.trim()) {
        _this.setValue(results[0][0].transcript.trim(), _extends({}, options, {
          triggerCustomQuery: true,
          triggerDefaultQuery: true
        }));
      }
    };

    _this._stopMic = function () {
      if (_this._micInstance) {
        _this._micInstance.stop();

        _this._micInstance = null;

        _this._setMicStatus(MIC_STATUS.inactive);
      }
    };

    _this._setMicStatus = function (status, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var prevStatus = _this._micStatus;
      _this._micStatus = status;

      _this._applyOptions(options, 'micStatus', prevStatus, _this._micStatus);
    };

    var backendName = backendAlias[mongodb ? 'MONGODB' : 'ELASTICSEARCH']; // eslint-disable-next-line

    var schema = SCHEMA[backendName];
    validateSchema(_extends({
      index: index,
      url: url,
      credentials: credentials,
      mongodb: mongodb,
      appbaseConfig: appbaseConfig,
      headers: headers,
      transformRequest: transformRequest,
      transformResponse: transformResponse,
      enablePopularSuggestions: enablePopularSuggestions,
      enablePredictiveSuggestions: enablePredictiveSuggestions,
      autocompleteField: autocompleteField,
      highlightConfig: highlightConfig
    }, rsAPIConfig), schema, backendName, componentsAlias.SEARCHCOMPONENT, componentName);
    var _id = rsAPIConfig.id,
        type = rsAPIConfig.type,
        _react = rsAPIConfig.react,
        queryFormat = rsAPIConfig.queryFormat,
        _dataField = rsAPIConfig.dataField,
        categoryField = rsAPIConfig.categoryField,
        categoryValue = rsAPIConfig.categoryValue,
        nestedField = rsAPIConfig.nestedField,
        _from = rsAPIConfig.from,
        _size = rsAPIConfig.size,
        _sortBy = rsAPIConfig.sortBy,
        _value = rsAPIConfig.value,
        aggregationField = rsAPIConfig.aggregationField,
        aggregationSize = rsAPIConfig.aggregationSize,
        _after = rsAPIConfig.after,
        includeNullValues = rsAPIConfig.includeNullValues,
        _includeFields = rsAPIConfig.includeFields,
        _excludeFields = rsAPIConfig.excludeFields,
        _fuzziness = rsAPIConfig.fuzziness,
        searchOperators = rsAPIConfig.searchOperators,
        highlight = rsAPIConfig.highlight,
        highlightField = rsAPIConfig.highlightField,
        customHighlight = rsAPIConfig.customHighlight,
        interval = rsAPIConfig.interval,
        aggregations = rsAPIConfig.aggregations,
        missingLabel = rsAPIConfig.missingLabel,
        showMissing = rsAPIConfig.showMissing,
        _defaultQuery = rsAPIConfig.defaultQuery,
        _customQuery = rsAPIConfig.customQuery,
        execute = rsAPIConfig.execute,
        enableSynonyms = rsAPIConfig.enableSynonyms,
        selectAllLabel = rsAPIConfig.selectAllLabel,
        pagination = rsAPIConfig.pagination,
        queryString = rsAPIConfig.queryString,
        distinctField = rsAPIConfig.distinctField,
        distinctFieldConfig = rsAPIConfig.distinctFieldConfig,
        recentSuggestionsConfig = rsAPIConfig.recentSuggestionsConfig,
        popularSuggestionsConfig = rsAPIConfig.popularSuggestionsConfig,
        maxPredictedWords = rsAPIConfig.maxPredictedWords,
        urlField = rsAPIConfig.urlField,
        rankFeature = rsAPIConfig.rankFeature,
        enableRecentSearches = rsAPIConfig.enableRecentSearches,
        enableRecentSuggestions = rsAPIConfig.enableRecentSuggestions,
        applyStopwords = rsAPIConfig.applyStopwords,
        stopwords = rsAPIConfig.stopwords;

    if (!_id) {
      throw new Error(errorMessages.invalidComponentId);
    } // dataField is required for components other then search


    if (type && type !== queryTypes.Search && type !== queryTypes.Suggestion) {
      if (Array.isArray(_dataField)) {
        throw new Error(errorMessages.dataFieldAsArray);
      }
    }

    _this.id = _id;
    _this.type = mongodb && type === queryTypes.Suggestion ? queryTypes.Search : type;
    _this.react = _react;
    _this.queryFormat = queryFormat;
    _this.dataField = _dataField;
    _this.autocompleteField = autocompleteField;
    _this.highlightConfig = highlightConfig;
    _this.categoryField = categoryField;
    _this.categoryValue = categoryValue;
    _this.nestedField = nestedField;
    _this.from = _from;
    _this.size = _size;
    _this.sortBy = _sortBy;
    _this.aggregationField = aggregationField;
    _this.aggregationSize = aggregationSize;
    _this.after = _after;
    _this.includeNullValues = includeNullValues;
    _this.includeFields = _includeFields;
    _this.excludeFields = _excludeFields;
    _this.fuzziness = _fuzziness;
    _this.searchOperators = searchOperators;
    _this.highlight = highlight;
    _this.highlightField = highlightField;
    _this.customHighlight = customHighlight;
    _this.interval = interval;
    _this.aggregations = aggregations;
    _this.missingLabel = missingLabel;
    _this.showMissing = showMissing;
    _this.execute = execute;
    _this.enableSynonyms = enableSynonyms;
    _this.selectAllLabel = selectAllLabel;
    _this.pagination = pagination;
    _this.queryString = queryString;
    _this.defaultQuery = _defaultQuery;
    _this.customQuery = _customQuery;
    _this.beforeValueChange = beforeValueChange;
    _this.onValueChange = onValueChange;
    _this.onResults = onResults;
    _this.onAggregationData = onAggregationData;
    _this.onError = onError;
    _this.onRequestStatusChange = onRequestStatusChange;
    _this.onQueryChange = onQueryChange;
    _this.onMicStatusChange = onMicStatusChange;
    _this.distinctField = distinctField;
    _this.distinctFieldConfig = distinctFieldConfig;
    _this.enableRecentSearches = enableRecentSearches;
    _this.enableRecentSuggestions = enableRecentSuggestions;
    _this.recentSuggestionsConfig = recentSuggestionsConfig;
    _this.popularSuggestionsConfig = popularSuggestionsConfig;
    _this.maxPredictedWords = maxPredictedWords;
    _this.urlField = urlField;
    _this.rankFeature = rankFeature;
    _this.applyStopwords = applyStopwords;
    _this.stopwords = stopwords; // other properties

    _this.enablePopularSuggestions = enablePopularSuggestions;
    _this.maxPopularSuggestions = maxPopularSuggestions;
    _this.showDistinctSuggestions = showDistinctSuggestions;
    _this.enablePredictiveSuggestions = enablePredictiveSuggestions;
    _this.preserveResults = preserveResults;
    _this.clearOnQueryChange = clearOnQueryChange; // Initialize the state changes observable

    _this.stateChanges = new Observable();
    _this.results = new Results(_results);
    _this.aggregationData = new Aggregations();

    if (_value) {
      _this.setValue(_value, {
        stateChanges: true
      });
    } else {
      _this.value = _value;
    }

    return _this;
  } // getters


  var _proto = SearchComponent.prototype;

  /* -------- Private methods only for the internal use -------- */
  _proto._appendResults = function _appendResults(rawResults) {
    if (this.preserveResults && rawResults && Array.isArray(rawResults.hits && rawResults.hits.hits) && Array.isArray(this.results.rawData && this.results.rawData.hits && this.results.rawData.hits.hits)) {
      this.results.setRaw(_extends({}, rawResults, {
        hits: _extends({}, rawResults.hits, {
          hits: [].concat(this.results.rawData.hits.hits, rawResults.hits.hits)
        })
      }));
    } else {
      this.results.setRaw(rawResults);
    }
  } // Method to apply the changed based on set options
  ;

  _proto._applyOptions = function _applyOptions(options, key, prevValue, nextValue) {
    // // Trigger mic events
    if (key === 'micStatus' && this.onMicStatusChange) {
      this.onMicStatusChange(nextValue, prevValue);
    } // Trigger events


    if (key === 'query' && this.onQueryChange) {
      this.onQueryChange(nextValue, prevValue);
    }

    if (key === 'value' && this.onValueChange) {
      this.onValueChange(nextValue, prevValue);
    }

    if (key === 'error' && this.onError) {
      this.onError(nextValue);
    }

    if (key === 'results' && this.onResults) {
      this.onResults(nextValue, prevValue);
    }

    if (key === 'aggregationData' && this.onAggregationData) {
      this.onAggregationData(nextValue, prevValue);
    }

    if (key === 'requestStatus' && this.onRequestStatusChange) {
      this.onRequestStatusChange(nextValue, prevValue);
    }

    if (options.triggerDefaultQuery) {
      this.triggerDefaultQuery();
    }

    if (options.triggerCustomQuery) {
      this.triggerCustomQuery();
    }

    if (options.stateChanges !== false) {
      var _this$stateChanges$ne;

      this.stateChanges.next((_this$stateChanges$ne = {}, _this$stateChanges$ne[key] = {
        prev: prevValue,
        next: nextValue
      }, _this$stateChanges$ne), key, this);
    }
  };

  _proto._getSearchIndex = function _getSearchIndex() {
    var index = this.index;

    if (this._parent && this._parent.index) {
      index = this._parent.index;
    }

    return index;
  };

  _proto._fetchRequest = function _fetchRequest(requestBody) {
    var _this2 = this;

    // remove undefined properties from request body
    var requestOptions = {
      method: 'POST',
      body: JSON.stringify(_extends({}, requestBody, !!this.mongodb && {
        mongodb: this._getMongoRequest()
      })),
      headers: _extends({}, this.headers)
    };
    return new Promise(function (resolve, reject) {
      _this2._handleTransformRequest(requestOptions).then(function (finalRequestOptions) {
        // set timestamp in request
        var timestamp = Date.now(); // START: applicable for es

        var suffix = '_reactivesearch.v3';

        var requestOptionsWithHeader = _extends({}, finalRequestOptions, {
          headers: _extends({}, finalRequestOptions.headers, !_this2.mongodb ? {
            'x-timestamp': timestamp
          } : {})
        });

        var index = _this2._getSearchIndex();

        return fetch("" + _this2.url + (_this2.mongodb ? '' : "/" + index + "/" + suffix), requestOptionsWithHeader).then(function (res) {
          var responseHeaders = res.headers; // check if search component is present

          if (res.headers) {
            var queryID = res.headers.get('X-Search-Id');

            if (queryID) {
              // if parent exists then set the queryID to parent
              if (_this2._parent) {
                _this2._parent.setQueryID(queryID);
              } else {
                _this2.setQueryID(queryID);
              }
            }
          }

          if (res.status >= 500) {
            return reject(res);
          }

          if (res.status >= 400) {
            return reject(res);
          }

          return res.json().then(function (data) {
            _this2._handleTransformResponse(data).then(function (transformedData) {
              if (transformedData && Object.prototype.hasOwnProperty.call(transformedData, 'error')) {
                reject(transformedData);
              }

              var response = _extends({}, transformedData, {
                _timestamp: timestamp,
                _headers: responseHeaders
              });

              return resolve(response);
            })["catch"](function (e) {
              console.warn('SearchBase: transformResponse rejected the promise with ', e);
              return reject(e);
            });
          });
        })["catch"](function (e) {
          return reject(e);
        });
      })["catch"](function (e) {
        console.warn('SearchBase: transformRequest rejected the promise with ', e);
        return reject(e);
      });
    });
  } // Method to generate the final query based on the component's value changes
  ;

  _proto._generateQuery = function _generateQuery() {
    var _this3 = this;

    /**
     * This method performs the following tasks to generate the query
     * 1. Get all the watcher components for a particular component ID
     * 2. Make the request payload
     * 3. Execute the final query
     * 4. Update results and trigger events => Call `setResults` or `setAggregations` based on the results
     */
    if (this._parent) {
      var components = this._parent.getComponents();

      var watcherComponents = []; // Find all the  watcher components

      Object.keys(components).forEach(function (id) {
        var componentInstance = components[id];

        if (componentInstance && componentInstance.react) {
          var flattenReact = flatReactProp(componentInstance.react, id);

          if (flattenReact.indexOf(_this3.id) > -1) {
            watcherComponents.push(id);
          }
        }
      });
      var requestQuery = {}; // Generate the request body for watchers

      watcherComponents.forEach(function (watcherId) {
        var component = _this3._parent.getComponent(watcherId);

        if (component) {
          requestQuery[watcherId] = component.componentQuery; // collect queries for all components defined in the `react` property
          // that have some value defined

          var flattenReact = flatReactProp(component.react, component.id);
          flattenReact.forEach(function (id) {
            // only add if not present
            if (!requestQuery[id]) {
              var dependentComponent = _this3._parent.getComponent(id);

              if (dependentComponent && dependentComponent.value) {
                // Set the execute to `false` for dependent components
                var query = dependentComponent.componentQuery;
                query.execute = false;

                if (query.type === queryTypes.Suggestion) {
                  query.type = queryTypes.Search;

                  if (dependentComponent.categoryField) {
                    query.categoryValue = dependentComponent.categoryValue;
                  }
                } // Add the query to request payload


                requestQuery[id] = query;
              }
            }
          });
        }
      });
      return {
        requestBody: Object.values(requestQuery),
        orderOfQueries: watcherComponents
      };
    }

    return {
      requestBody: [],
      orderOfQueries: []
    };
  };

  _proto._handleTransformResponse = function _handleTransformResponse(res) {
    if (this.transformResponse && typeof this.transformResponse === 'function') {
      return this.transformResponse(res);
    }

    return new Promise(function (resolve) {
      return resolve(res);
    });
  };

  _proto._handleTransformRequest = function _handleTransformRequest(requestOptions) {
    if (this.transformRequest && typeof this.transformRequest === 'function') {
      return this.transformRequest(requestOptions);
    }

    return new Promise(function (resolve) {
      return resolve(requestOptions);
    });
  };

  _proto._handleAggregationResponse = function _handleAggregationResponse(aggsResponse, options, append) {
    if (options === void 0) {
      options = defaultOptions;
    }

    if (append === void 0) {
      append = true;
    }

    var aggregationField = this.aggregationField;

    if (!aggregationField && typeof this.dataField === 'string') {
      aggregationField = this.dataField;
    }

    if (aggregationField) {
      var _prev3 = this.aggregationData;
      this.aggregationData.setRaw(aggsResponse[aggregationField]);
      this.aggregationData.setData(aggregationField, aggsResponse[aggregationField] && aggsResponse[aggregationField].buckets, this.preserveResults && append);

      this._applyOptions({
        stateChanges: options.stateChanges
      }, 'aggregationData', _prev3, this.aggregationData);
    }
  };

  _proto._setError = function _setError(error, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    this._setRequestStatus(REQUEST_STATUS.error);

    var prev = this.error;
    this.error = error;

    this._applyOptions(options, 'error', prev, this.error);
  };

  _proto._setRequestStatus = function _setRequestStatus(requestStatus) {
    var prev = this.requestStatus;
    this.requestStatus = requestStatus;

    this._applyOptions({
      stateChanges: true
    }, 'requestStatus', prev, this.requestStatus);
  } // Method to set the default query value
  ;

  _proto._updateQuery = function _updateQuery(query) {
    var _this4 = this;

    var prevQuery;
    prevQuery = _extends({}, this._query);
    var finalQuery = [this.componentQuery];
    var flattenReact = flatReactProp(this.react, this.id);
    flattenReact.forEach(function (id) {
      // only add if not present
      var watcherComponent = _this4._parent.getComponent(id);

      if (watcherComponent && watcherComponent.value) {
        // Set the execute to `false` for watcher components
        var watcherQuery = watcherComponent.componentQuery;
        watcherQuery.execute = false;

        if (watcherQuery.type === queryTypes.Suggestion) {
          watcherQuery.type = queryTypes.Search;

          if (watcherComponent.categoryField) {
            watcherQuery.categoryValue = watcherComponent.categoryValue;
          }
        } // Add the query to request payload


        finalQuery.push(watcherQuery);
      }
    });
    this._query = query || finalQuery;

    this._applyOptions({
      stateChanges: false
    }, 'query', prevQuery, this._query);
  } // mic
  ;

  _proto._getMongoRequest = function _getMongoRequest() {
    var mongodb = {};

    if (this.index) {
      mongodb.index = this.index;
    }

    if (this.mongodb) {
      if (this.mongodb.db) {
        mongodb.db = this.mongodb.db;
      }

      if (this.mongodb.collection) {
        mongodb.collection = this.mongodb.collection;
      }
    }

    return mongodb;
  };

  _createClass(SearchComponent, [{
    key: "micStatus",
    get: function get() {
      return this._micStatus;
    }
  }, {
    key: "micInstance",
    get: function get() {
      return this._micInstance;
    }
  }, {
    key: "micActive",
    get: function get() {
      return this._micStatus === MIC_STATUS.active;
    }
  }, {
    key: "micInactive",
    get: function get() {
      return this._micStatus === MIC_STATUS.inactive;
    }
  }, {
    key: "micDenied",
    get: function get() {
      return this._micStatus === MIC_STATUS.denied;
    }
  }, {
    key: "query",
    get: function get() {
      return this._query;
    }
  }, {
    key: "requestPending",
    get: function get() {
      return this.requestStatus === REQUEST_STATUS.pending;
    }
  }, {
    key: "appbaseSettings",
    get: function get() {
      var _ref4 = this.appbaseConfig || {},
          recordAnalytics = _ref4.recordAnalytics,
          customEvents = _ref4.customEvents,
          enableQueryRules = _ref4.enableQueryRules,
          userId = _ref4.userId;

      return {
        recordAnalytics: recordAnalytics,
        customEvents: customEvents,
        enableQueryRules: enableQueryRules,
        userId: userId
      };
    } // To remove when mongo-backend starts supporting type:suggestion
    // To get the parsed suggestions from the results

  }, {
    key: "suggestions",
    get: function get() {
      if (this.type && this.type !== queryTypes.Search) {
        return [];
      }

      if (this.results) {
        var fields = getNormalizedField(this.dataField) || [];

        if (fields.length === 0 && this.results.data && Array.isArray(this.results.data) && this.results.data.length > 0 && this.results.data[0]) {
          // Extract fields from _source
          fields = Object.keys(this.results.data[0]).filter(function (key) {
            return !['_id', '_click_id', '_index', '_score', '_type'].includes(key);
          });
        }

        if (this.enablePopularSuggestions) {
          // extract suggestions from popular suggestion fields too
          fields = [].concat(fields);
        }

        return getSuggestions(fields, this.results.data, this.value, this.showDistinctSuggestions, this.enablePredictiveSuggestions); // .slice(0, this.size);
      }

      return [];
    } // Method to get the raw query based on the current state

  }, {
    key: "componentQuery",
    get: function get() {
      return _extends({
        id: this.id,
        type: this.type,
        dataField: getNormalizedField(this.dataField)
      }, this.mongodb && {
        autocompleteField: this.autocompleteField,
        highlightConfig: this.highlightConfig
      }, {
        react: this.react,
        highlight: this.highlight,
        highlightField: getNormalizedField(this.highlightField),
        fuzziness: this.fuzziness,
        searchOperators: this.searchOperators,
        includeFields: this.includeFields,
        excludeFields: this.excludeFields,
        size: this.size,
        from: this.from,
        queryFormat: this.queryFormat,
        sortBy: this.sortBy,
        fieldWeights: getNormalizedWeights(this.dataField),
        includeNullValues: this.includeNullValues,
        aggregationField: this.aggregationField,
        aggregationSize: this.aggregationSize,
        categoryField: this.categoryField,
        missingLabel: this.missingLabel,
        showMissing: this.showMissing,
        nestedField: this.nestedField,
        interval: this.interval,
        customHighlight: this.customHighlight,
        customQuery: this.customQuery ? this.customQuery(this) : undefined,
        defaultQuery: this.defaultQuery ? this.defaultQuery(this) : undefined
      }, this.value && {
        value: this.value
      }, {
        categoryValue: this.categoryValue,
        after: this.after,
        aggregations: this.aggregations,
        enableSynonyms: this.enableSynonyms,
        selectAllLabel: this.selectAllLabel,
        pagination: this.pagination,
        queryString: this.queryString,
        distinctField: this.distinctField,
        distinctFieldConfig: this.distinctFieldConfig,
        index: this.index,
        showDistinctSuggestions: this.showDistinctSuggestions,
        enablePredictiveSuggestions: this.enablePredictiveSuggestions,
        maxPredictedWords: this.maxPredictedWords,
        urlField: this.urlField,
        rankFeature: this.rankFeature,
        popularSuggestionsConfig: this.popularSuggestionsConfig,
        recentSuggestionsConfig: this.recentSuggestionsConfig,
        enablePopularSuggestions: this.enablePopularSuggestions,
        enableRecentSearches: this.enableRecentSearches,
        enableRecentSuggestions: this.enableRecentSuggestions,
        applyStopwords: this.applyStopwords,
        stopwords: this.stopwords
      });
    }
  }, {
    key: "queryId",
    get: function get() {
      // Get query ID from parent(searchbase) if exist
      if (this._parent && this._parent._queryId) {
        return this._parent._queryId;
      } // For single components just return the queryId from the component


      if (this._queryId) {
        return this._queryId;
      }

      return '';
    }
  }, {
    key: "mappedProps",
    get: function get() {
      var _this5 = this;

      var mappedProps = {};

      var searchBaseMappingsLocal = _extends({}, searchBaseMappings);

      if (this.mongodb) {
        delete searchBaseMappingsLocal.recordClick;
        delete searchBaseMappingsLocal.recordConversions;
      }

      Object.keys(searchBaseMappings).forEach(function (key) {
        // $FlowFixMe
        mappedProps[searchBaseMappings[key]] = _this5[key];
      });
      return mappedProps;
    }
    /* -------- Public methods -------- */
    // mic click handler

  }]);

  return SearchComponent;
}(Base);

/**
 * SearchBase class will act like the ReactiveBase component.
 * It works as a centralized store that will have the info about active/registered components.
 */
var SearchBase = /*#__PURE__*/function (_Base) {
  _inheritsLoose(SearchBase, _Base);

  /* ------ Private properties only for the internal use ----------- */
  // active components
  function SearchBase(_ref) {
    var _this;

    var index = _ref.index,
        url = _ref.url,
        credentials = _ref.credentials,
        mongodb = _ref.mongodb,
        headers = _ref.headers,
        appbaseConfig = _ref.appbaseConfig,
        transformRequest = _ref.transformRequest,
        transformResponse = _ref.transformResponse,
        libAlias = _ref.libAlias;
    _this = _Base.call(this, {
      index: index,
      url: url,
      credentials: credentials,
      mongodb: mongodb,
      headers: headers,
      appbaseConfig: appbaseConfig,
      transformRequest: transformRequest,
      transformResponse: transformResponse,
      libAlias: libAlias
    }) || this;

    _this.register = function (componentId, component) {
      if (!componentId) {
        throw new Error(errorMessages.invalidComponentId);
      }

      if (_this._components[componentId]) {
        // return existing instance
        return _this._components[componentId];
      }

      var componentInstance = component;

      if (component && !(component instanceof SearchComponent)) {
        // create instance from object with all the options
        componentInstance = new SearchComponent(_extends({}, component, {
          id: componentId,
          index: component.index || _this.index,
          url: component.url || _this.url,
          mongodb: component.mongodb || _this.mongodb,
          credentials: component.credentials || _this.credentials,
          headers: component.headers || _this.headers,
          transformRequest: component.transformRequest || _this.transformRequest,
          transformResponse: component.transformResponse || _this.transformResponse,
          appbaseConfig: component.appbaseConfig || _this.appbaseConfig
        }));
      } else {
        // set the id property on instance
        componentInstance.id = componentId;
      } // register component


      _this._components[componentId] = componentInstance; // set the search base instance as parent

      componentInstance.setParent(_assertThisInitialized(_this));
      return componentInstance;
    };

    _this.unregister = function (componentId) {
      if (componentId) {
        delete _this._components[componentId];
      }
    };

    _this.getComponent = function (componentId) {
      return _this._components[componentId];
    };

    _this.getComponents = function () {
      return _this._components;
    };

    _this._components = {};
    return _this;
  } // To register a component


  return SearchBase;
}(Base);

export { LIBRARY_ALIAS, SearchBase, SearchComponent };
